import { render, staticRenderFns } from "./collectionDublicateModal.vue?vue&type=template&id=67d0e300&"
import script from "./collectionDublicateModal.vue?vue&type=script&lang=js&"
export * from "./collectionDublicateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports